{
  "error": "Errore",
  "help": "Aiuto",
  "info": "Informazioni",
  "success": "Operazione riuscita",
  "warning": "Avvertenza"
}
